'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'circle-dashed';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e105';
var svgPathData = 'M36.7 232c-18.8 0-33.8-16.3-29.5-34.6 6.4-27.3 17.2-53 31.6-76.1 9.9-16 32-17 45.3-3.7l.7 .7c11.4 11.4 12.3 29.4 4.3 43.5-7.5 13.3-13.5 27.6-17.6 42.6-4.3 15.5-17.7 27.7-33.8 27.7l-1 0zM162.2 88.7c-14.1 7.9-32 7.1-43.5-4.3l-.7-.7c-13.3-13.3-12.4-35.4 3.7-45.3 23.2-14.4 48.8-25.2 76.1-31.6 18.3-4.3 34.6 10.6 34.6 29.5l0 1c0 16.1-12.1 29.5-27.7 33.8-15 4.2-29.3 10.1-42.6 17.6zM280.5 474.8c0-16.1 12.1-29.5 27.7-33.8 15-4.2 29.3-10.2 42.6-17.6 14-7.9 32-7.1 43.5 4.3l.7 .7c13.3 13.3 12.4 35.4-3.7 45.4-23.2 14.4-48.8 25.1-76.1 31.6-18.3 4.3-34.6-10.6-34.6-29.5l0-1zM423.8 350.2c7.5-13.3 13.5-27.6 17.6-42.6 4.3-15.5 17.7-27.7 33.8-27.7l1 0c18.8 0 33.8 16.3 29.5 34.6-6.4 27.3-17.2 53-31.6 76.1-9.9 16-32 17-45.4 3.7l-.7-.7c-11.4-11.4-12.3-29.4-4.3-43.5zM118.1 428.4l.7-.7c11.4-11.4 29.4-12.3 43.5-4.3 13.3 7.5 27.6 13.5 42.6 17.6 15.5 4.3 27.7 17.7 27.7 33.8l0 1c0 18.8-16.3 33.8-34.6 29.5-27.3-6.4-53-17.2-76.1-31.6-16-9.9-17-32-3.7-45.4zM38.8 390.8C24.4 367.6 13.6 342 7.2 314.6 2.9 296.3 17.9 280 36.7 280l1 0c16.1 0 29.5 12.1 33.8 27.7 4.2 15 10.1 29.3 17.6 42.6 7.9 14 7.1 32-4.3 43.5l-.7 .7c-13.3 13.3-35.4 12.4-45.3-3.7zM394.9 83.6l-.7 .7c-11.4 11.4-29.4 12.3-43.5 4.3-13.3-7.5-27.6-13.5-42.6-17.6-15.5-4.3-27.7-17.7-27.7-33.8l0-1c0-18.8 16.3-33.8 34.6-29.5 27.3 6.4 53 17.2 76.1 31.6 16 9.9 17 32 3.7 45.3zm28.9 78.1c-7.9-14.1-7.1-32 4.3-43.5l.7-.7c13.3-13.3 35.4-12.4 45.4 3.7 14.4 23.2 25.1 48.8 31.6 76.1 4.3 18.3-10.6 34.6-29.5 34.6l-1 0c-16.1 0-29.5-12.1-33.8-27.7-4.2-15-10.2-29.3-17.6-42.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDashed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;